import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/logo_wwt.png'


const _withScopeId = n => (_pushScopeId("data-v-4d624092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
}, null, -1))
const _hoisted_3 = { class: "hamb-icon-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-sliders-h",
  style: {"font-size":"24px"}
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-regular fa-info-circle" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-star" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "hamb-menu-items" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.rocketcenter.com/INTUITIVEPlanetarium/InteractiveAstronomy",
    target: "_blank",
    style: {"text-decoration":"none","color":"inherit"},
    onmouseover: "this.style.textDecoration='none';",
    onmouseout: "this.style.textDecoration='none';"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-rocket" }),
    /*#__PURE__*/_createElementVNode("i", null, " INTUITIVE"),
    /*#__PURE__*/_createElementVNode("sup", null, "®"),
    /*#__PURE__*/_createTextVNode(" Planetarium ")
  ])
], -1))
const _hoisted_9 = { class: "bg-menu-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"text-shadow":"0px 0px 5px black"},
  class: "bg-menu-text"
}, "Sky survey: ", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "intro-container"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-times",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { style: {"font-size":"18px","font-family":"'Roboto'","margin-bottom":"1em"} }
const _hoisted_16 = {
  class: "text",
  style: {"font-size":"14px","margin-bottom":"1em"}
}
const _hoisted_17 = { style: {"font-size":"14px","margin-bottom":"1em"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","margin-bottom":"1em"} }, [
  /*#__PURE__*/_createTextVNode(" Interactive created by "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/ADavidWeigel",
    target: "_blank",
    class: "links",
    style: {"margin-right":"0.5em"}
  }, "A. David Weigel"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/in/erika-s-a37431153/",
    target: "_blank",
    class: "links",
    style: {"margin-right":"0.5em"}
  }, "Érika Silva"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://newton.cx/~peter/",
    target: "_blank",
    class: "links",
    style: {"margin-right":"0.5em"}
  }, "Peter K. G. Williams"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.jcarifio.com/projects",
    target: "_blank",
    class: "links",
    style: {"margin-right":"0.5em"}
  }, "Jon Carifio")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://worldwidetelescope.org/home/",
    target: "_blank",
    class: "links"
  }, [
    /*#__PURE__*/_createTextVNode(" Powered by WorldWide Telescope"),
    /*#__PURE__*/_createElementVNode("a", null, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "WWT Logo",
        src: _imports_0,
        width: "20",
        height: "20",
        style: {"vertical-align":"middle","margin-left":"0.5em"}
      })
    ])
  ])
], -1))
const _hoisted_20 = {
  key: 1,
  class: "description-container"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-times",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { style: {"font-size":"18px","margin-bottom":"1em"} }
const _hoisted_24 = { style: {"font-size":"16px","margin-bottom":"1em"} }
const _hoisted_25 = { style: {"font-size":"16px"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"font-size":"16px","margin-left":"0.5em"} }, " - ", -1))
const _hoisted_27 = ["href"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"vertical-align":"middle","margin-left":"0.5em"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-solid fa-rocket",
    style: {"margin-right":"0.5em"}
  })
], -1))
const _hoisted_29 = {
  class: "modal",
  id: "modal-loading"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" }),
  /*#__PURE__*/_createElementVNode("p", null, "Loading …")
], -1))
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorldWideTelescope = _resolveComponent("WorldWideTelescope")!
  const _component_folder_view = _resolveComponent("folder-view")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    id: "app",
    style: _normalizeStyle(_ctx.cssVars)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WorldWideTelescope, {
          "wwt-namespace": _ctx.wwtNamespace,
          onPointerdown: _ctx.wwtOnPointerDown,
          onPointermove: _ctx.wwtOnPointerMove,
          onPointerup: _ctx.wwtOnPointerUp
        }, null, 8, ["wwt-namespace", "onPointerdown", "onPointermove", "onPointerup"]),
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "menu-toggle",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _hoisted_5),
          _createElementVNode("div", {
            class: _normalizeClass({ fullscreen: _ctx.fullscreen })
          }, [
            _createElementVNode("button", {
              class: "fullscreen-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFullscreen && _ctx.toggleFullscreen(...args)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.fullscreen ? 'fas fa-compress fa-lg' : 'fas fa-expand fa-lg')
              }, null, 2)
            ])
          ], 2),
          _createElementVNode("ul", {
            class: _normalizeClass(["hamb-menu-container", {'show': _ctx.isMenuOpen }])
          }, [
            _createElementVNode("li", {
              class: "hamb-menu-items",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openIntro && _ctx.openIntro(...args)))
            }, [
              _hoisted_6,
              _createTextVNode(" Overview ")
            ]),
            _createElementVNode("li", {
              class: "hamb-menu-items",
              style: {"cursor":"pointer"},
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleBgButton && _ctx.toggleBgButton(...args)))
            }, [
              _hoisted_7,
              _createTextVNode(" Choose sky survey ")
            ]),
            _hoisted_8
          ], 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("select", {
            style: {"text-shadow":"0px 0px 2px black"},
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.curForegroundImagesetName) = $event)),
            class: "bg-menu",
            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideMenu && _ctx.hideMenu(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgroundImagesets, (bg) => {
              return (_openBlock(), _createElementBlock("option", {
                value: bg.imagesetName,
                key: bg.imagesetName,
                class: "custom-option"
              }, _toDisplayString(bg.displayName), 9, _hoisted_11))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.curForegroundImagesetName]
          ])
        ], 512), [
          [_vShow, _ctx.showBgButton]
        ]),
        (_ctx.showIntro)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "close-intro",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeIntro && _ctx.closeIntro(...args)))
              }, _hoisted_14),
              _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.introTitle), 1),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.introText), 1),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.introInstructions), 1),
              _hoisted_18,
              _hoisted_19
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDescription)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "close-description",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeDescription && _ctx.closeDescription(...args)))
              }, _hoisted_22),
              _createElementVNode("h1", _hoisted_23, _toDisplayString(_ctx.descrTitles), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.descriptions), 1),
              _createElementVNode("p", _hoisted_25, [
                _createElementVNode("i", null, " Credits: " + _toDisplayString(_ctx.descrCredits), 1),
                _hoisted_26,
                _createElementVNode("a", {
                  href: _ctx.descrCreditsURL,
                  target: "_blank",
                  class: "links"
                }, [
                  _hoisted_28,
                  _createTextVNode("Learn more ")
                ], 8, _hoisted_27)
              ])
            ], 512)), [
              [_vShow, !_ctx.showBgButton]
            ])
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_29, _hoisted_31, 512), [
              [_vShow, _ctx.isLoading]
            ])
          ]),
          _: 1
        }),
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleFolderView && _ctx.toggleFolderView(...args)))
        }, [
          (_ctx.imagesetFolder !== null)
            ? (_openBlock(), _createBlock(_component_folder_view, {
                key: 0,
                sliders: "",
                expandable: "",
                thumbnails: true,
                open: _ctx.mobile ? true : true,
                "root-folder": _ctx.imagesetFolder,
                incomingItemSelect: _ctx.incomingItemSelect,
                "flex-direction": "column",
                onSelect: _ctx.onItemSelected,
                onOpacity: _ctx.onOpacityChanged
              }, null, 8, ["open", "root-folder", "incomingItemSelect", "onSelect", "onOpacity"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.showFolderView]
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}